import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const complianceCheckOverrideAtom = createMutationAtomFactory(
  'trade.complianceCheckOverride',
  (params: { id: string; overrideReason: string; notes: string }) => ({
    tradeComplianceCheckOverride: {
      __args: {
        id: params.id,
        input: {
          overrideReason: params.overrideReason,
          notes: params.notes,
        },
      },
      id: true,
      status: true,
      overrideReason: true,
      overriddenAt: true,
    },
  }),
);
